import { render } from "./Perlindungan.vue?vue&type=template&id=f22a08ee"
import script from "./Perlindungan.vue?vue&type=script&lang=js"
export * from "./Perlindungan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__